import type { TFunction } from "i18next";
import dayjs from "dayjs";
import { tokens } from "../styles/tokens";
import { formatOrderTime } from "./formatLocaleDate";

const { color: T } = tokens;

// Shared by Staff.tsx and AdminAccounts.tsx — don't reintroduce a second copy
// of these in either screen (ref: CLAUDE.md "duplicated logic across code
// paths" hazard).
export function getInitials(name: string): string {
  const parts = name.trim().split(" ");
  return parts.length >= 2
    ? ((parts[0]![0] ?? "") + (parts[parts.length - 1]![0] ?? "")).toUpperCase()
    : name.slice(0, 2).toUpperCase();
}

const AVATAR_COLORS = [T.brand, T.successBright, T.infoText, T.purpleMid, T.avatarPink, T.warningText, T.avatarCyan];
export function getAvatarColor(name: string): string {
  let h = 0;
  for (const c of name) h = (h * 31 + c.charCodeAt(0)) & 0xffff;
  return AVATAR_COLORS[h % AVATAR_COLORS.length] ?? T.brand;
}

export function formatLastLogin(raw: string | null | undefined, t: TFunction, lng: string): string {
  if (!raw) return t("staff.none");
  const d = dayjs(raw);
  const today = dayjs().startOf("day");
  if (d.isAfter(today)) return t("staff.lastLoginToday", { time: formatOrderTime(raw, lng) });
  const diff = today.diff(d.startOf("day"), "day");
  if (diff === 1) return t("staff.lastLoginYesterday");
  return t("staff.lastLoginDaysAgo", { count: diff });
}
